<template>
  <div class="page">
    <TopNav
        :username="username"
        :balance="balance"
        :currency="currency"
        activeLv1="lotto"
        activeLv2="result"
        @nav="onNav"
        @sub="onSub"
    />

    <div class="wrap">
      <div class="toolbar">
        <span class="label">{{$t('result.Date')}}</span>

        <div class="date-picker-wrap">
          <div class="date-input-box" @click.stop="showCalendar = !showCalendar">
            <input 
              type="text" 
              class="date-input-field" 
              :value="displayDate" 
              @input="onDateInput"
              placeholder="DD-MM-YYYY"
            />
          </div>
          <img src="@/assets/img/icon_v2.gif" class="date-icon" @click.stop="showCalendar = !showCalendar" />

          <!-- 自定义日历弹窗 -->
          <div v-if="showCalendar" class="calendar-popup" v-click-outside="closeCalendar">
            <div class="cal-header">
              <span class="cal-btn" @click="prevMonth">&lt;</span>
              <span class="curr">{{ calMonthName }} {{ calYear }}</span>
              <span class="cal-btn" @click="nextMonth">&gt;</span>
            </div>
            <div class="cal-weekdays">
              <span v-for="d in $t('result.weekdays')" :key="d">{{ d }}</span>
            </div>
            <div class="cal-days">
              <span v-for="d in prevMonthDays" :key="'prev-'+d" class="other-month"></span>
              <span 
                v-for="d in daysInMonth" 
                :key="d" 
                :class="{ active: isSelected(d) }"
                @click="selectDay(d)"
              >{{ d }}</span>
            </div>
          </div>
        </div>

        <button class="btn" @click="load()">{{$t('result.GetResult')}}</button>
        <button class="btn" @click="setToday()">{{$t('result.Today')}}</button>
        <button class="btn" @click="setYesterday()">{{$t('result.Yesterday')}}</button>
      </div>

      <table class="tbl">
        <colgroup>
          <col width="3.13%" />
          <col width="9.22%" />
          <col width="7.03%" />
          <col width="6.06%" />
          <col width="49.04%" />
          <col width="6.13%" />
          <col width="11.72%" />
          <col width="7.66%" />
        </colgroup>
        <thead>
        <tr>
          <th class="c-no">{{$t('result.No')}}</th>
          <th class="c-date">{{$t('result.Date')}}</th>
          <th class="c-title">{{$t('result.Title')}}</th>
          <th class="c-result">{{$t('result.Result')}}</th>
          <th class="c-detail">{{$t('result.Detail')}}</th>
          <th class="c-bonus">{{$t('result.Bonus')}}</th>
          <th class="c-uo">{{$t('result.UnderOver')}}</th>
          <th class="c-range">{{$t('result.Range')}}</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(r, i) in rows" :key="r.issueNo || (r.date + '_' + r.title)">
          <td class="center">{{ i + 1 }}</td>
          <td class="center">{{ r.date }}</td>
          <td class="center">{{ r.title }}</td>
          <td class="center b-bold">{{ r.result }}</td>
          <td class="center">{{ r.detail }}</td>
          <td class="center"></td>
          <td class="center">{{ fmtUO(r.uo || r.underOver) }}</td>
          <td class="center">{{ r.range }}</td>
        </tr>

        <tr v-if="!rows.length">
          <td colspan="5" class="empty">-</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import TopNav from "@/components/TopNav.vue";
import { getResultListApi } from "@/api/result";
import { getWalletBalanceApi } from "@/api/wallet";

export default {
  components: { TopNav },
  data() {
    return {
      rows: [],
      date: "", // YYYY-MM-DD
      showCalendar: false,
      calMonth: new Date(), // 用于日历显示的月份
  
      username: this.$store.getters["auth/user"]?.username || "",
      currency: "KHR",
      balance: 0
    };
  },
  directives: {
    "click-outside": {
      bind(el, binding) {
        el.clickOutsideEvent = function(event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      }
    }
  },
  computed: {
    displayDate() {
      if (!this.date) return "";
      const [y, m, d] = this.date.split("-");
      return `${d}-${m}-${y}`;
    },
    calMonthName() {
      const names = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      return names[this.calMonth.getMonth()];
    },
    calYear() {
      return this.calMonth.getFullYear();
    },
    daysInMonth() {
      const year = this.calMonth.getFullYear();
      const month = this.calMonth.getMonth();
      return new Date(year, month + 1, 0).getDate();
    },
    prevMonthDays() {
      const year = this.calMonth.getFullYear();
      const month = this.calMonth.getMonth();
      return new Date(year, month, 1).getDay();
    }
  },
  mounted() {
    this.$updateViewport(1280);
    this.setToday();
    this.loadHeader();
    this.load();
  },
  methods: {
    onNav(key) {
      if (key === "news") {
        this.$router.push("/lotto");
        return;
      }
      if (key === "lotto") {
        this.$router.push("/lotto");
        return;
      }
      if (key === "lottery") {
        this.$router.push("/lottery");
        return;
      }
      if (key === "report") {
        this.$router.push("/report");
        return;
      }
      if (key === "balance") {
        this.$router.push("/balance");
        return;
      }
      if (key === "changePassword") {
        this.$router.push("/change-password");
        return;
      }
      alert("Coming soon");
    },
    onSub(key) {
      if (key === "lotto") return this.$router.push("/lotto");
      if (key === "result") return this.$router.push("/result");
      if (key === "winResult" || key === "winResultV1") return this.$router.push("/report");
      alert("Coming soon");
    },

    async loadHeader() {
      try {
        const res = await getWalletBalanceApi();
        const d = res && res.data ? res.data : res;
        this.currency = d.currency || "KHR";
        this.balance = Number(d.displayBalance ?? 0);
      } catch (e) {
        console.error(e);
      }
    },

    setToday() {
      const d = new Date();
      this.date = this.toYMD(d);
      this.load();
    },
    setYesterday() {
      const d = new Date();
      d.setDate(d.getDate() - 1);
      this.date = this.toYMD(d);
      this.load();
    },
    toYMD(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    },

    async load() {
      if (!this.date) return;
      try {
        const res = await getResultListApi(this.date, 0, 500);
        const d = res && res.data ? res.data : res;
        this.rows = Array.isArray(d) ? d : [];
      } catch (e) {
        console.error(e);
        this.rows = [];
      }
    },

    fmtUO(v) {
      // 统一展示成 Under / Over
      if (!v) return "";
      const s = String(v).toUpperCase();
      if (s === "UNDER") return "Under";
      if (s === "OVER") return "Over";
      return v;
    },

    fmtDate(val) {
      if (!val) return "";
      if (val.includes("-")) {
        let [y, m, d] = val.split("-");
        return `${d}-${m}-${y}`;
      }
      return val;
    },

    onDateInput(e) {
      const val = e.target.value;
      // 匹配 DD-MM-YYYY 格式
      const reg = /^(\d{2})-(\d{2})-(\d{4})$/;
      const match = val.match(reg);
      if (match) {
        const d = match[1];
        const m = match[2];
        const y = match[3];
        this.date = `${y}-${m}-${d}`;
        this.load();
      }
    },

    // ===== 日历逻辑 =====
    closeCalendar() {
      this.showCalendar = false;
    },
    prevMonth() {
      const d = new Date(this.calMonth);
      d.setMonth(d.getMonth() - 1);
      this.calMonth = d;
    },
    nextMonth() {
      const d = new Date(this.calMonth);
      d.setMonth(d.getMonth() + 1);
      this.calMonth = d;
    },
    selectDay(day) {
      const y = this.calMonth.getFullYear();
      const m = String(this.calMonth.getMonth() + 1).padStart(2, "0");
      const d = String(day).padStart(2, "0");
      this.date = `${y}-${m}-${d}`;
      this.showCalendar = false;
      this.load();
    },
    isSelected(day) {
      const y = this.calMonth.getFullYear();
      const m = String(this.calMonth.getMonth() + 1).padStart(2, "0");
      const d = String(day).padStart(2, "0");
      return this.date === `${y}-${m}-${d}`;
    }
  }
};
</script>

<style scoped>
.page { background:#fff; min-height:100vh; min-width: 1280px; }
.wrap { padding:10px; }

.toolbar{
  display:flex;
  align-items:center;
  gap:8px;
  height: 30px;
  margin-bottom:12px;
}

.label{ font-size:13px; font-weight:700; color:#454545; }

/* 日历组件样式 */
.date-picker-wrap {
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
}
.date-input-box {
  width: 110px;
  height: 23px;
  border: 1px solid #7F9DB9;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0;
  cursor: text;
  box-sizing: border-box;
}
.date-input-field {
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0 5px;
  font-size: 13px;
  color: #000;
  font-family: Arial;
  outline: none;
  background: transparent;
}
.date-icon {
  width: 25px;
  height: 20px;
  cursor: pointer;
}

.calendar-popup {
  position: absolute;
  top: 25px;
  left: 0;
  width: 212px;
  background: #FFFFFF;
  border: 1px solid #A6A6A6;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 1000;
  padding: 2px;
  font-family: Arial, sans-serif;
  color: #454545;
}
.cal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #E6E6E6;
  height: 28px;
  padding: 0 8px;
  font-weight: bold;
  font-size: 14px;
}
.cal-btn {
  width: 18px;
  height: 18px;
  background: #666;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 10px;
  font-weight: bold;
  user-select: none;
}
.cal-btn:hover { background: #444; }
.cal-weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  margin-top: 8px;
  padding: 0 2px;
}
.cal-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0;
  margin-top: 5px;
  padding: 0 2px 5px 2px;
}
.cal-days span {
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F6F6F6;
  border: 1px solid #D9D9D9;
  margin: -0.5px;
  font-size: 12px;
  cursor: pointer;
  box-sizing: border-box;
}
.cal-days span:hover {
  background: #FFFA90;
}
.cal-days span.active {
  background: #FFFA90;
}
.cal-days span.other-month {
  background: transparent;
  border: 0;
  cursor: default;
}

.btn{
  min-width: 80px;
  width: auto;
  padding: 0 8px;
  height: 23px;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  background: #DFE8FF;
  color: #27448C;
  border: 1px solid #7F9DB9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}
.btn:hover { background: #cfdcff; }

.tbl { 
  width:100%; 
  border-collapse:collapse; 
  font-size:13px; 
  border: 1px solid #ddd;
  table-layout: fixed;
}
.tbl th {
  background:#8000FF;
  color:#FFFFFF;
  border:1px solid #ddd;
  height: 25px;
  padding: 0 5px;
  font-weight: normal;
  white-space:nowrap;
  box-sizing: border-box;
}
.tbl td {
  border:1px solid #ddd;
  height: 25px;
  padding: 0 5px;
  vertical-align:middle;
  color: #000000;
  font-weight: normal;
  box-sizing: border-box;
}

.c-no, .c-date, .c-title, .c-result, .c-detail, .c-bonus, .c-uo, .c-range { width: auto; }

.tbl tbody tr {
  background: #FFFFFF !important;
}

.b-bold { color: #000000; font-weight: normal; }

.center{ text-align:center; white-space:nowrap; }
.detail{ font-size:12px; line-height:1.4; color: #000000; word-break: break-all; text-align: center; padding: 0 10px; }

.empty{ padding:30px; text-align:center; color:#777; font-size: 14px; }
</style>
